import { render, staticRenderFns } from "./cartIcon.vue?vue&type=template&id=84882dba&scoped=true&"
import script from "./cartIcon.vue?vue&type=script&lang=js&"
export * from "./cartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84882dba",
  null
  
)

export default component.exports